import { BaseApi } from '@/main/baseApi';

import { NAME as PARTNER } from '../partner/constants';
import { DMS_MODULE, NAME } from './constants';

class GdprApiProvider extends BaseApi {
	GDPR_LOG = 'Log';

	gdprLogTableSchema() {
		return this.fetch(`${this.apiPath}${this.GDPR_LOG}Schema`);
	}

	gdprLogTableData(params: any) {
		return this.fetch(`${this.apiPath}${this.GDPR_LOG}Rows`, params);
	}
}

export const apiProvider = new GdprApiProvider(DMS_MODULE, PARTNER, NAME);
